<!-- Map -->
<div class="map-container column-map right-pos-map no-fix-scroll-map hid-mob-map" [ngClass]="toggleClass ? '' : 'fixed-mobile'" style="height: 100%;">
    <div id="map-main">
        <div style="height: 100%;width: 100%;position: absolute;top: 0px;left: 0px;background-color: rgb(229, 227, 223);">
        <iframe width="100%" height="100%"  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.14615365208!2d72.71603444904773!3d19.082177211190135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1722571947497!5m2!1sen!2sin"
                                            style="border:0;" allowfullscreen="" loading="lazy"
                                            referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </div>
    <ul class="mapnavigation no-list-style">
        <li><a href="#" class="prevmap-nav mapnavbtn"><span><i class="fas fa-caret-left"></i></span></a></li>
        <li><a href="#" class="nextmap-nav mapnavbtn"><span><i class="fas fa-caret-right"></i></span></a></li>
    </ul>
    <div class="scrollContorl mapnavbtn tolt" data-microtip-position="top-left" data-tooltip="Enable Scrolling"><span><i
                class="fal fa-unlock"></i></span></div>
    <div class="location-btn geoLocation tolt" data-microtip-position="top-left" data-tooltip="Your location"><span><i
                class="fal fa-location"></i></span></div>
    <div class="map-overlay"></div>
    <div class="map-close" (click)="filterEvent()"><i class="fas fa-times"></i></div>
</div>
<!-- Map end -->
<!-- hidden-search-column-->
<div class="hidden-search-column">
    <div class="hidden-search-column-container fl-wrap full-height tabs-act">
        <app-business-filters [businessList]="businessList"></app-business-filters>
    </div>
</div>
<div class="close_sbfilters" (click)="filterEvent()" [ngClass]="toggleClass ? '' : 'd-none'"><i class="fal fa-long-arrow-right"></i></div>
<!-- hidden-search-column end-->
<div class="col-list-wrap anim_clw" [ngClass]="toggleClass ? 'hidsb_act' : ''">
    <app-business-list #businessList (editedEvent)="eventHandler($event)"></app-business-list>
    <app-sub-footer></app-sub-footer>
</div>
<div class="limit-box fl-wrap"></div>
